import { useEffect, lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { initAttribution } from "@/lib/analytics";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Gallery from "@/pages/Gallery";
import Quote from "@/pages/Quote";
import Business from "@/pages/Business";
import Track from "@/pages/Track";
import Proof from "@/pages/Proof";
import GiftCards from "@/pages/GiftCards";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
const Admin = lazy(() => import("@/pages/Admin"));
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Faq from "@/pages/Faq";
import NotFound from "@/pages/NotFound";
import Portfolio from "@/pages/Portfolio";
import CaseStudy from "@/pages/CaseStudy";
import LocalPage from "@/pages/LocalPage";
import { LOCAL_PAGES } from "@/data/local";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  useEffect(() => { initAttribution(); }, []);
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain bg-[#050505] min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <CartProvider>
          <Navbar />
          <CartDrawer />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/:slug" element={<ProductDetail />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/quote" element={<Quote />} />
            <Route path="/business" element={<Business />} />
            <Route path="/track" element={<Track />} />
            <Route path="/proof/:token" element={<Proof />} />
            <Route path="/gift-cards" element={<GiftCards />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin" element={<Suspense fallback={<main className="pt-40 min-h-screen" />}><Admin /></Suspense>} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/portfolio/:slug" element={<CaseStudy />} />
            {LOCAL_PAGES.map((p) => <Route key={p.slug} path={`/${p.slug}`} element={<LocalPage />} />)}
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
        </CartProvider>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: { background: "#121212", border: "1px solid #27272A", color: "#EDEDED", borderRadius: 0 },
        }}
      />
    </div>
  );
}

export default App;
